import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhPandas, dhTable, vsGraph, vsPreview } from '@deephaven/icons';
import { useApi } from '@deephaven/jsapi-bootstrap';
import { jsx as _jsx } from "react/jsx-runtime";
function ObjectIcon(_ref) {
  var type = _ref.type;
  var dh = useApi();
  switch (type) {
    case dh.VariableType.TABLE:
    case dh.VariableType.TABLEMAP:
    case dh.VariableType.TREETABLE:
    case dh.VariableType.HIERARCHICALTABLE:
    case dh.VariableType.PARTITIONEDTABLE:
      return /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: dhTable
      });
    case dh.VariableType.FIGURE:
      return /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsGraph
      });
    case dh.VariableType.PANDAS:
      return /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: dhPandas
      });
    default:
      return /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsPreview
      });
  }
}
export default ObjectIcon;
//# sourceMappingURL=ObjectIcon.js.map